import { createAPI } from "../apisServer";
import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("email");

const reqFechamentoFiscal = {
	listar: async function (params) {
		return apiServer
			.get("email/v1/fechamento-fiscal", {
				headers: { banco: banco },
				params,
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	ultimoEnvio: async function () {
		return apiServer
			.get("email/v1/fechamento-fiscal/ultimo-envio", {
				headers: { banco: banco },
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	transmitir: async function (body) {
		return apiServer
			.post("email/v1/fechamento-fiscal", body, {
				headers: { banco: banco },
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqFechamentoFiscal;
